module.exports = __webpack_public_path__ + "img/question-xuqiu-active.76070ba8.png";